var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"chartbpm",attrs:{"height":"350px","width":"1000px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }